import { QuerySetResults_State } from '~/core/state/types/state-results.schema';

/**
 * Counts the total number of results in the given sets
 *
 * @param sets - sets to count results from
 * @param filterSetsByLayoutPosition - if provided, will filter sets based on layout position
 * @param filterSetsByName - if provided, will filter sets based on name
 *
 * @returns total number of results in the given sets
 */
const countResults = (
    sets: Array<QuerySetResults_State>,
    filterSetsByLayoutPosition?: string[],
    filterSetsByName?: string[]
): number => {
    return sets
        .filter((set) => {
            if (
                filterSetsByLayoutPosition !== undefined &&
                filterSetsByLayoutPosition.length > 0 &&
                set.layoutPosition
            ) {
                return !filterSetsByLayoutPosition.includes(set.layoutPosition);
            }

            if (filterSetsByName !== undefined && filterSetsByName.length > 0) {
                return !filterSetsByName.includes(set.querySetIdentifier);
            }

            return true;
        })
        .reduce((acc, set) => acc + set.totalRecords, 0);
};

export default countResults;
